import React, { Suspense } from 'react';
import SplashScreen from 'views/Pages/SplashScreen';

export const Loadable = (Component: any) => (props:any) =>
  (
    <Suspense fallback={<SplashScreen></SplashScreen>}>
      <Component {...props} />
    </Suspense>
  );
